<template>
  <v-container fluid class="report-home-page pa-4">
    <div class="report-top-card">
      <div class="report-header">
        <div>
          <div class="report-title">Reports</div>
          <div class="report-subtitle">
            Open sales, inventory, customer, payment, and expense reports.
          </div>
        </div>
      </div>
    </div>

    <div class="report-content">
      <v-row dense>
        <v-col cols="12" md="6">
          <ProfitAndLoss />
          <Sale />
          <Inventory />
          <Product />
          <Payment />
          <Purchase />
        </v-col>

        <v-col cols="12" md="6">
          <Customer />
          <Invoice />
          <Order />
          <Expense />
        </v-col>
      </v-row>
    </div>

    <DateSelector @submit="openReport" />
  </v-container>
</template>

<script>
import Customer from "../components/Customer";
import Product from "../components/Product";
import Invoice from "../components/Invoice";
import Payment from "../components/Payment";
import Order from "../components/Order";
import Expense from "../components/Expense";
import Purchase from "../components/Purchase";
import ProfitAndLoss from "../components/ProfitAndLoss";
import Sale from "../components/Sale";
import Inventory from "../components/Inventory";
import DateSelector from "@/modules/Report/components/DateSelector";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "report-home",

  components: {
    Customer,
    Inventory,
    Sale,
    Product,
    Invoice,
    Expense,
    ProfitAndLoss,
    Purchase,
    Payment,
    Order,
    DateSelector,
  },

  computed: {
    ...mapGetters("reportView", ["getReportName"]),
    ...mapGetters("global", ["currentBusiness"]),
  },

  created() {
    document.title = "smplsale - Reports";
  },

  methods: {
    ...mapActions("reportView", ["setReportName"]),

    openReport(val) {
      if (!this.getReportName) {
        this.$swal({
          icon: "warning",
          title: "Select Report",
          text: "Please select a report first.",
        });
        return;
      }

      const routeData = this.$router.resolve({
        path: `/reportView/${this.getReportName}?start=${val.start}&end=${val.end}`,
      });

      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
.report-home-page {
  background: #f8fafc;
  min-height: 100%;
}

.report-top-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 16px;
}

.report-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.report-title {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
}

.report-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: 2px;
}

.report-content {
  padding: 0;
}

@media (max-width: 600px) {
  .report-home-page {
    padding: 10px !important;
  }
}
</style>